import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './card.jade'
import * as models from '../../models'
import '../seasons'
import moment from 'moment'

@Component('sporty')
@Template(template)
@Attribute('obj-id', String)
@Attribute('obj-class', String)
@Attribute('header', String)
@Attribute('keys', JSON)

export default class Card extends HTMLElement {
  get obj() {
    return models[this.objClass].instance(this.objId)
  }
  get translations() {
    return {
      'team': 'Player team',
      'pos': 'Position on field',
      'shirt': 'T-shirt number',
      'uid': 'UID',
      'startTime': 'Start time & date',
    }
  }
  startTime(time) {
    return moment(time).format('MMMM Do, h:mm A')
  }
  getValue(obj, key) {
    const value = obj[key]
    if(key === 'startTime') {
      return this.startTime(value)
    }
    return value
  }
}
